import {
  IonCard,
  IonCol, IonGrid, IonLabel, IonRow, IonSelect, IonSelectOption,
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import {
  SelectColor,
  Widget, WidgetSection,
} from '../../../../interfaces/PluginInterface/PluginInterface';
import ENVIRONMENT from '@/environments/environment';
import classNames from 'classnames';
import styles from '../../Plugin.module.scss';
import stylesConfig from '../PluginConfig.module.scss';
interface PluginFormProps {
  formData?: WidgetSection;
  widgetType?: Widget;
  handleInputUpdate: (arg0: any) => void;
}

export const WidgetCustomWrapper: React.FC<PluginFormProps> = ({ formData, widgetType, handleInputUpdate }) => {


  const [widgetStyles, setWidgetStyles] = useState({
    background_color: formData?.widgets[0].background_color,
    buttons_color: formData?.widgets[0].buttons_color,
  });


  const optionsBackground: SelectColor[] = [
    {
      value: "pepper-pink",
    },
    {
      value: 'pepper-white',
    },
    {
      value: 'pepper-transparent',
    },
  ];
  const optionsButtons: SelectColor[] = [
    {
      value: "red",
    },
    {
      value: 'green',
    },
    {
      value: 'black',
    },
  ];

  useEffect(() => {
    if (formData?.widgets[0]) {
      setWidgetStyles((prevStyles) => ({
        ...prevStyles,
        background_color: formData?.widgets[0].background_color || prevStyles.background_color || '', // Valor por defecto si no se encuentra
        buttons_color: formData?.widgets[0].buttons_color || prevStyles.buttons_color || '', // Valor por defecto si no se encuentra
      }));


    }
  }
    , [formData?.widgets[0]]);


  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${ENVIRONMENT.ECOMMERCE_WIDGET_STYLE}`;
    document.head.appendChild(link);

    // Limpieza: elimina el enlace cuando el componente se desmonte
    return () => {
      document.head.removeChild(link);
    };
  }, []);



  // Actualiza los estilos dinámicamente según las selecciones del usuario
  const handleStyleChange = (name: string, value: string) => {
    setWidgetStyles((prevStyles) => ({
      ...prevStyles,
      [name]: value, // Cambia el color según la selección
    }));
    handleInputUpdate({
      target: {
        name: 'background_color',
        value: name === 'background_color' ? value : formData?.widgets[0].background_color,
      },
    });
    handleInputUpdate({
      target: {
        name: 'buttons_color',
        value: name === 'buttons_color' ? value : formData?.widgets[0].buttons_color,
      },
    });
  };

  // Cambia el color según la selección
  const selectedColorWidget = (value: string) => {
    switch (value) {
      case 'red':
        return 'pepper-btn-red';
      case 'green':
        return 'pepper-btn-green';
      case 'black':
        return 'pepper-btn-black';
      case 'pepper-pink':
        return 'pepper-pink';
      case 'pepper-white':
        return 'pepper-white';
      case 'pepper-transparent':
        return 'pepper-transparent';
      default:
        return value; // Devuelve el valor si no coincide
    }
  };

  return (
    <IonGrid>
      <IonRow
        className={classNames(styles.pluginInputWrapper, stylesConfig.sectionCustomWrapper)}>
        {/* Selector para el color de fondo y botones */}
        <IonCol
          size="12"
          size-sm="12"
          size-md="6"
          size-lg="6"
          className={classNames(stylesConfig.selectorCol)}
        >
          <div className={classNames(stylesConfig.selectorWrapper)}>
            <IonLabel className={classNames(styles.labelWidgeForm)}>Color de fondo</IonLabel>
            <IonSelect
              name="background_color"
              labelPlacement="stacked"
              placeholder="Selecciona un color"
              interface="popover"
              className={classNames(styles.pluginInput, stylesConfig.pluginSelect, styles.widgetStdInput)}
              value={widgetStyles.background_color}
              onIonChange={(e) => handleStyleChange('background_color', e.detail.value)}
            >
              {optionsBackground.map((option: SelectColor) => (
                <IonSelectOption key={option.value} value={option.value}>
                  {option.value}
                </IonSelectOption>
              ))}
            </IonSelect>
          </div>

          <div className={classNames(stylesConfig.selectorWrapper)}>
            <IonLabel className={classNames(styles.labelWidgeForm)}>Color de botones</IonLabel>
            <IonSelect
              name="buttons_color"
              labelPlacement="stacked"
              placeholder="Selecciona un color"
              interface="popover"
              className={classNames(styles.pluginInput, stylesConfig.pluginSelect, styles.widgetStdInput)}
              value={widgetStyles.buttons_color}
              onIonChange={(e) => handleStyleChange('buttons_color', e.detail.value)}
            >
              {optionsButtons.map((option: SelectColor) => (
                <IonSelectOption key={option.value} value={option.value}>
                  {option.value}
                </IonSelectOption>
              ))}
            </IonSelect>
          </div>
        </IonCol>

        {/* IonCard para la vista previa */}
        <IonCol
          className={classNames(stylesConfig.cardWrapperCustom)}
          size="12"
          size-sm="12"
          size-md="6"
          size-lg="6"
          class='preview-col'
        >
          <div
            className={classNames(
              stylesConfig.widgetCustomContainer,
              'pepperfont',
              'pepper-text-14',
              'pepper-pill-container',
              'pepper-flex-center',
              selectedColorWidget(widgetStyles.background_color!) // Clase dinámica basada en el color seleccionado
            )}
            data-pepper-widget="STD"
          >
            <div className="pepper-pill-left">
              <a href="https://pepperfinance.es/como-funciona/" target="_blank" rel="noopener noreferrer">
                <div className="pepper-logo-btn"></div>
              </a>
            </div>
            <div className="pepper-text-right">
              <div className="pepper-titlebox">
                <div className="pepper-text-16 pepper-bold">Simula tus pagos</div>
                <div className="pepper-information">
                  <div className="pepper-info-img pepper-pointer" id="btnInfoPepper"></div>
                </div>
              </div>
              <div className="pepper-textbox pepper-text-14">
                <span id="lblPaymentPepper" className="pepper-bold">28,78</span>€/mes en
                <div className="pepper-container-line pepper-container-line-simulator">
                  <div className="pepper-minus-btn-container">
                    <div className={`pepper-minus-btn ${selectedColorWidget(widgetStyles.buttons_color!)}`} id="btnDecPepper">
                      <div className="pepper-minus-btn-content pepper-btn-content-light"></div>
                    </div>
                  </div>
                  <p className="pepper-bold pepper-text-14" id="lblTermPepper">9</p>
                  <div className="pepper-plus-btn-container">
                    <div className={`pepper-plus-btn pepper-disabled ${selectedColorWidget(widgetStyles.buttons_color!)}`} id="btnIncPepper">
                      <div className="pepper-plus-btn-content pepper-btn-content-light"></div>
                      <div className="pepper-plus-btn-content2 pepper-btn-content-light"></div>
                    </div>
                  </div>
                </div>
                <div className="pepper-container-line">
                  <div className="pepper-text-14">cuotas</div>
                </div>
              </div>
            </div>
          </div>

        </IonCol>
      </IonRow>
    </IonGrid>
  );
};